import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Table } from "@/features/Table";
import { type C5DataUpload, data_upload_columns } from "./columns";
import UploadPopover from "@/components/UploadPopover";
import { type FilterC5DataUploadSchema, C5DataUploadFilter } from "./filter";
import { C5DataUploadNew } from "./new";
import { useQueryClient } from "@tanstack/react-query";
import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";

export const C5DataUploadTable = () => {
  const [searchParams] = useSearchParams();
  const [files, setFiles] = useState<File[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<string | null>(null);
  const client = searchParams.get("client") || Clients.C5;

  const QueryClient = useQueryClient();
  const refreshList = async () => {
    // In v5, this invalidates all queries whose key starts with the prefix
    await QueryClient.invalidateQueries({
      queryKey: [client, ClientTables.C5_DATA_UPLOAD, "get"],
    });
  };

  return (
    <Table<C5DataUpload, FilterC5DataUploadSchema>
      label="Chargement de fichiers"
      client={client}
      table_name={ClientTables.C5_DATA_UPLOAD}
      columns={data_upload_columns}
      filter={<C5DataUploadFilter />}
      disable_translations_request={true}
      new_item={
        <UploadPopover
          uploader={({ setIsOpen }) => (
            <C5DataUploadNew
              setIsOpen={setIsOpen}
              files={files}
              setFiles={setFiles}
              selectedConfig={selectedConfig}
              setSelectedConfig={setSelectedConfig}
              onSuccess={async () => {
                await refreshList();
              }}
            />
          )}
        />
      }
    />
  );
};
